import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import './LoginPage.css'; 
import { LoginApi, AcademicYearApi, YearApi } from './Api/All_Api';
import { Input, Select } from 'antd';
import { UserOutlined,EyeInvisibleOutlined, EyeTwoTone, LockOutlined  } from '@ant-design/icons';
import { Option } from 'antd/es/mentions';
import image from './Assets/logo1-removebg-preview.png';

const LoginPage = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [academicYears, setAcademicYears] = useState([]);  
  const [selectedYear, setSelectedYear] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    // Check if an academic year is selected
    if (!userName) {
      toast.warn('Please Enter User Name.');
      return;
    }
    if (!password) {
      toast.warn('Please Enter Password.');
      return;
    }
    if (!selectedYear) {
      toast.warn('Please select year.');
      return;
    }

    const bodyData ={
      loginId: userName,
      password: password,
    }
    try {
      const response = await axios.post(`${LoginApi}?year=${selectedYear}`, bodyData);

       if (response.data == 'NOTFOUND') {
        
        toast.warn('User is notfound !!', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      else if (response.data == 'BLOCKED') {
       
        toast.warn('User is blocked', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      else if (response.data !== null) {
       
        console.log("===>>>Login Successful<<<===")
        // toast.success('Login successful!', {
        //   position: "top-right",
        //   autoClose: 3000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });   
        
        const data = response.data;
        const userData = response.data.user;
        const token = response.data.token;
  
        sessionStorage.setItem("userData", JSON.stringify(userData));     
        sessionStorage.setItem("sessionYear", userData.sessionYear);       
        sessionStorage.setItem("role", userData.isAdmin); 
        sessionStorage.setItem("userId", userData.id); 
        sessionStorage.setItem("branchId", userData.branchId); 
        sessionStorage.setItem("branchName", userData.branchName); 
        sessionStorage.setItem("userName", userData.name); 
        sessionStorage.setItem("token", token); 

        navigate('/dashboard');
      } 

    } catch (error) {
      toast.error('Invalid userName or Password.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const fetchAcademicYears = async () => {
    try {
      const response = await axios.get(YearApi); 
      setAcademicYears(response.data); 
     
    } catch (error) {
      toast.error('Error fetching academic years.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    fetchAcademicYears();
  }, []);

// const handleLogin = async (e) => {
//     e.preventDefault();

//     // Check if an academic year is selected
//     if (!userName) {
//       toast.error('Please Enter An User Name.');
//       return;
//     }
//     if (!password) {
//       toast.error('Please Enter An Password.');
//       return;
//     }


//       if (userName == "admin" && password == "123") {
//         toast.success('Login successful!', {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//         });     
//         navigate('/dashboard');
//       } else {
//         toast.error('Invalid userName or Password', {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//         });
      
//     } 
//   };

  return (
    <>
      {/* <div className='container-fluid' style={{height:"100vh"}}>
        <div className='row m-0 LoginPage'>
            <div className='col-12 col-md-2 col-lg-8'></div>
            <div className='col-12 col-md-8 col-lg-4' style={{border:"2px solid red"}}>
                <div className='row p-2'>
                    <div className='col-12 p-0'>
                      <form className="login"  onSubmit={handleLogin}>

                        <div className='pb-3 text-center'><h3><b>Rock Ledger</b></h3></div>

                        <div className='row m-0 mt-2'>
                            <Input className='border py-2'
                              type="text"
                              placeholder="Enter Username"
                              value={userName}
                              onChange={(e) => setuserName(e.target.value)}
                            />
                        </div>

                         <div className='row m-0 mt-2'>
                            <Input className='border py-2'
                              type="password"
                              placeholder="Enter Password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                        <div className='row mt-2'>
                            <Select
                              id="academicYear"
                              value={selectedYear || undefined}
                              onChange={setSelectedYear}
                              placeholder="Select Year"
                              optionFilterProp="children"
                            >
                              <option disabled>Select Year</option>
                              {academicYears.map(year => (
                                <Option key={year.id} value={year.year}>
                                  {year.yearLabel}
                                </Option>
                              ))}
                            </Select>
                        </div>

                        <div className='text-center mt-3'>
                          <button type="submit" style={{backgroundColor:"#ce6571",border:"none",color:"#fff"}} className='p-0 px-4 py-1 rounded'>Login</button>
                        </div>

                        <div className='text-center mt-3' style={{color:"black"}}>
                          <span style={{fontSize:"12px"}}>Managed By: TechnoAarv Solution</span>
                        </div>

                      </form>
                    </div>
                </div>
            </div>
            <div className='col-12 col-md-2 col-lg-12'></div>
        </div>
      </div> */}


      <div className="row loginPage p-0 m-0" >
          <div className="container-fluid  d-flex align-items-center justify-content-center">

                    <div className="row p-0 m-0">

                      <div className="col-12 col-lg-2 col-xs-12"></div>

                      <div className="col-12 col-lg-8 col-xs-12">

                        <div className="row p-3 display pb-5 pb-md-3" style={{border:"2px solid white"}}>

                              <div className="col-12 col-md-6 col-lg-7 col-sm-12 col-xs-12" style={{padding:"10px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                                <div className="row text-center py-3"> 
                                    <div className="col-12">
                                        <img src={image} alt="image" style={{width:"200px",height:"200px"}} />
                                    </div>
                                    <div className="col-12">
                                        <span style={{fontSize:"28px",fontWeight:"bold",color:"orange",letterSpacing:"10px",textShadow:"2px 2px 5px"}}>ROCK LEDGER</span>
                                    </div>  

                                    <div className="col-12 col-md-6 col-lg-8 text-center pt-5 pb-3 pb-md-5 text-white fixed-bottom" style={{fontSize:"14px"}}>
                                    <span> &copy; 2025 Designed & Developed By TechnoAarv</span>
                                </div>                            
                                    
                                </div>
                            </div>

                              <div className="col-12 col-md-6 col-lg-5 col-sm-12 col-xs-12 py-3 px-2 mb-3 mb-md-0 loginForm" >
                                <form onSubmit={handleLogin}  data-aos="fade-right">
                                <div className="row form-group px-2 py-3">
                                <h3 className="text-center pb-3" style={{color:"white",fontWeight:"bold"}}>LOGIN HERE</h3>

                                  <div className="col-12">
                                      <label htmlFor="exampleInputEmail1">Email Id</label>
                                      <Input 
                                        type="text" className='py-2'
                                        value={userName}
                                        onChange={(e) => setUserName(e.target.value)}
                                        required
                                        placeholder="Enter Username" prefix={<UserOutlined />} />
                                  </div>

                                  <div className="col-12">
                                    <label htmlFor="exampleInputEmail1">Password</label>
                                      <Input.Password
                                        type="password" className='py-2'
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        placeholder="Enter Password" prefix={<LockOutlined />}
                                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                      />
                                  </div>

                                  <div className="col-12">
                                  <label htmlFor="exampleInputEmail1">Year</label>
                                      <Select className='w-100 '
                                        id="academicYear"
                                        value={selectedYear || undefined}
                                        onChange={setSelectedYear}
                                        placeholder="Select Year"
                                        optionFilterProp="children"
                                      >
                                        <Option disabled>Select Year</Option>
                                        {academicYears.map(year => (
                                          <Option key={year.id} value={year.year}>
                                            {year.yearLabel}
                                          </Option>
                                        ))}
                                      </Select>
                                 </div>

                                  {/* <div className="col-12 text-end pt-1">
                                    <span className='forgotPass'  type='submit'>Forgot Password ?</span>
                                  </div> */}
                            
                                  <div className="col-12 text-center pt-4">
                                    <button className='col-12 loginBtn'  type="submit">Login</button>
                                  </div>

                                </div>
                                </form>
                              </div>

                              

                        </div>

                      </div>

                      <div className="col-12 col-lg-2 col-xs-12"></div>

                  </div>
               
            </div>
      </div>
    </>
  );
};

export default LoginPage;
